import { Box, Icon, Menu, MenuItem, Typography } from "@outschool/backpack";
import { faCaretDown, faCaretRight } from "@outschool/icons";
import { TFunction } from "@outschool/localization";
import React from "react";

type SelectorProps = {
  options: Array<{ label: number | string; value: number }>;
  value: number | null;
  onChange: (value: number) => void;
  emptyLabel: string;
  t: TFunction;
};

const Selector = ({
  options,
  value,
  onChange,
  emptyLabel,
  t
}: SelectorProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        flex
        onClick={handleClick}
        sx={{
          borderRadius: "4px",
          justifyContent: "space-between",
          width: "100%",
          padding: "1rem",
          border: value !== null || open ? "2px solid" : "1px solid",
          alignItems: "center",
          borderColor: value !== null || open ? "primary.700" : "grey.100",
          backgroundColor: value !== null ? "primary.100" : undefined,
          color: value !== null ? "primary.700" : undefined,
          boxShadow:
            value !== null || open
              ? undefined
              : "1px 1px 5px rgba(0, 0, 0, 0.1)"
        }}
        aria-haspopup="true"
        aria-expanded={open}
        aria-label={t("Open dropdown menu")}
      >
        <Typography variant="h6">
          {options.find(o => o.value === value)?.label || emptyLabel}
        </Typography>
        <Icon
          icon={open ? faCaretDown : faCaretRight}
          color={open || value ? "primary" : undefined}
        />
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options.map(option => (
          <MenuItem
            key={option.value}
            value={option.value}
            onClick={() => {
              onChange(option.value);
              handleClose();
            }}
            sx={{
              paddingRight: "2em",
              width: anchorEl && anchorEl.offsetWidth
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Selector;
